<template>
  <div>
    <bread-crumb-cas :routeList="breadArray" labelType="common"></bread-crumb-cas>
    <top-bar :isShowSelect="isShowSelect" placeholder="请选择所属业务" :data="data" :clickAddButton="clickAddButton"></top-bar>
    <div class="search-bar">
      <div class="input-group">
        <el-input style="width: 32%;margin-left: 20px;" v-model="searchParam" placeholder="请输入活动分类名称"
          clearable></el-input>
        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <circle-table :tableData="tableData" @handleClick="handleClick"></circle-table>
    <pagination @sizePageChange="paginationChangeProduct" :paginationDatas="paginationDataProduct">
    </pagination>
    <el-drawer :visible.sync="dialogShowLabel" direction="rtl" size="40%" :destroy-on-close="true" :title="title"
      :isShowBtn="isShowBtn" :btnText="btnText" @clickHandler="addClickHandler" @one="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel">
      <div class="base-dialog">
        <el-form :rules="rules" :model="formList" label-width="120px" ref="formList">
          <el-form-item label="活动分类名称" prop="categoryName">
            <el-input v-model="formList.categoryName" class="base-dialog-input" autocomplete="off" type="text"
              placeholder="请输入" maxlength="30" show-word-limit required></el-input>
          </el-form-item>
          <el-form-item label="banner链接" prop="bannerLink">
            <el-input v-model="formList.bannerLink" class="base-dialog-input" autocomplete="off" type="text"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="跳转链接" prop="bannerJumpUrl">
            <el-input v-model="formList.bannerJumpUrl" class="base-dialog-input" autocomplete="off" type="text"
              placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="handleCancelActivateLabel">取消</el-button>
        <el-button type="primary" @click="() => { handleActivateLabel(title) }">
          确定</el-button>
      </div>
    </el-drawer>
    <modal :isShow.sync="moveDialog" title="移动" :isShowBtn="isShowBtn" :btnText="mergeMoveBtnText"
      @clickHandler="moveClickHandler" width="800px">
      <ContentLabelCascader :labelType="1" :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_moveContentLabel' }"
        ref="moveSelectedRef" />
    </modal>
    <modal :isShow.sync="mergeDialog" title="合并" :isShowBtn="isShowBtn" :btnText="mergeMoveBtnText"
      @clickHandler="mergeClickHandler">
      <ContentLabelCascader :labelType="1" :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_mergeContentLabel' }"
        ref="moveSelectedRef" />
    </modal>
    <modal :isShow.sync="deleteDialog" title="删除" :isShowBtn="isShowBtn" :btnText="btnText"
      @clickHandler="deleteClickHandler">
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal :isShow.sync="attributeShow" title="属性" :isShowBtn="isShowBtn" :btnText="btnText"
      @clickHandler="btnTextClickHandler">
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import circleTable from "./circleTable.vue"
import pagination from '../../../../../components/pagination'
import topBar from "../../../../../components/topBar"
import baseTable from "@/components/baseTable"
import ContentLabelCascader from '@/components/select/ContentLabelCascader';
import breadCrumbCas from "../../../../../components/breadCrumb.vue"
import modal from "../../../../../components/modal"
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import {
  saveOrUpdateLabelGroup,
  getTagAttributes,
  jdh_qz_man_activity_add_category,
  jdh_qz_man_activity_update_category,
  jdh_qz_man_activity_page_categories,
} from "../../../../../api/man.js"
import { mapState } from 'vuex';
import { uploadFile } from '@/utils/axios'
import { getBusinessId } from "../../../../../utils/enum"

export default {
  name: "commonLabel",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        callback()
      }
    }
    return {
      attributeShow: false, // 属性弹窗
      checkList: [
        {
          id: 2,
          name: '写手端不可见'
        },
        {
          id: 3,
          name: 'C端用户不可见'
        }],
      checkedCities: [],
      title: '',
      isRed: false,
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '活动分类ID',
            prop: 'categoryId',
            width: "120px"
          },
          {
            label: '活动分类名称',
            prop: 'categoryName'
          },
          {
            label: '创建时间',
            prop: 'createTime',
            width: "120px"
          },
          {
            label: '创建人',
            prop: 'createUser',
            width: "120px"
          },
        ],
        tableType: 4,
      },
      isShowSelect: false,

      // 删除弹框
      deleteDialog: false,
      data: [],
      times: null,
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      categoryName: "",
      dialogShow: false,
      dialogShowLabel: false,
      formList: {
        categoryName: "",
        bannerLink: "",
        bannerJumpUrl: "",
      },
      rules: {
        categoryName: [
          { validator: validatePass, trigger: 'blur' }
        ],
      },
      rules: {
        categoryName: [
          { required: true, message: '活动分类名称不得为空', trigger: 'change' }
        ],
      },
      invisibleStatus: '',
      breadArray: [
        {
          name: '标签管理',
          path: '',
          query: undefined,
        },
        {
          name: '通用标签',
          path: '/commonLabel/group',
          query: this.$router.query,
        }
      ],
      titlePicUrl: [],
      imgHost: process.env.VUE_APP_imgHost,
      searchParam: ""
    }
  },
  components: {
    baseTable,
    circleTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination,
    ContentLabelCascader,
    uploadImgUniversal
  },
  watch: {
    'formList.categoryName'(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: '禁止输入特殊字符',
          type: 'warning'
        });
        this.formList.categoryName = this.$utils.removalSpace(newValue)
      }
    },
    formList: {
      handler(newValue, oldValue) {
        this.isRed = false
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleSearch() {
      this.jdh_qz_man_activity_page_categories(this.searchParam)
    },
    handleReset() {
      this.jdh_qz_man_activity_page_categories()
      this.searchParam = ''
    },
    uploadFileEditor(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then(res => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch(error => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
    httpRequestEditor(request) {
      this.uploadFileEditor(request.file, msg => {
        let url = `//image.healthjd.com/da/` + msg;
        let html = '<img style="max-width:100%" src="' + url + '" />';
        this.editor.insertContent(html);
      });
    },
    // 获取businessId
    getBusinessId(key) {
      return getBusinessId(key)
    },
    changeCheck(val) {
      let numStatus = val.toString();
      let numStr1 = '2,3'
      let numStr2 = '3,2'
      if (numStatus == numStr1 || numStatus == numStr2) {
        this.invisibleStatus = 4
      } else {
        this.invisibleStatus = numStatus
      }
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === 'one') {
        this.attributeShow = false
        this.checkedCities = []
      } else if (val === 'two') {
        if (this.invisibleStatus == '') {
          this.invisibleStatus = '1'
        }
        getTagAttributes({
          tenantId: this.tableVal.tenantId,
          id: this.tableVal.id,
          invisibleStatus: this.invisibleStatus,
          // updateInvisibleStatusType: this.tableVal.yn
        }).then(res => {
          if (res) {
            this.checkedCities = [];
            this.$message({
              message: '操作成功',
              type: "success",
            });
            this.attributeShow = false;
          }
          this.jdh_qz_man_activity_page_categories()
        }).catch(err => {
          this.$message.error('操作失败');
        })
        this.attributeShow = false
      }
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.jdh_qz_man_activity_page_categories()
    },
    handleClick(val) {
      if (val.type === 'edit') {
        console.log("==== edit", val.val)
        this.dialogShowLabel = true
        this.title = "编辑"
        this.formList = {}
        setTimeout(() => {
          this.formList = val.val
        }, 500);

      } else if (val.type === 'goAdmin') {
        // 跳转标签下帖子
        this.$router.push({
          path: `/postEventManage`,
          query: { categoryId: val.val.categoryId }
        })
      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.formList = val.val
      } else if (val.type === 'attribute') {
        this.attributeShow = true
        this.tableVal = val.val
        // 属性值回显
        if (val.val.invisibleStatus !== 1) {
          if (val.val.invisibleStatus == 4) {
            this.checkedCities = [2, 3]
          } else {
            this.checkedCities = [val.val.invisibleStatus]
          }
        }
        this.invisibleStatus = val.val.invisibleStatus
      } else if (val.type === 'moveLabel') {
        this.moveDialog = true
        this.tableVal = val.val
      } else if (val.type === 'mergeLabel') {
        this.mergeDialog = true
        this.tableVal = val.val
      }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.jdh_qz_man_activity_update_category({
          ...this.formList,
          status: 2
        })
        // this.deleteDialog=false
      }
    },
    // 删除
    jdh_qz_man_activity_update_category(val) {
      console.log("==== delete", val)
      jdh_qz_man_activity_update_category({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        categoryId: val.categoryId,
        status: 2
      })
        .then(res => {
          if (res) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
          this.deleteDialog = false
          this.paginationDataProduct.currentPage = 1;
          this.jdh_qz_man_activity_page_categories()
        })
        .catch(res => {
          // if(res.data===-1) {
          this.$message.error(
            res.msg
          )
          // }
        })
    },
    // 新增弹框
    handleCancelActivateLabel() {
      this.dialogShowLabel = false
    },
    async handleActivateLabel(val) {
      await this.$refs['formList'].validate((valid) => {
        if (valid) {
          console.log('submit!')
          val == '新增' ?
            jdh_qz_man_activity_add_category({
              tenantId: this.$commonJs.getTenantId(),
              businessId: this.getBusinessId(this.$commonJs.getTenantId()),
              categoryName: this.formList.categoryName,
              bannerLink: this.formList.bannerLink,
              bannerJumpUrl: this.formList.bannerJumpUrl
            }).then((res) => {
              this.dialogShowLabel = false,
                this.jdh_qz_man_activity_page_categories()
            }) :
            jdh_qz_man_activity_update_category({
              tenantId: this.$commonJs.getTenantId(),
              businessId: this.getBusinessId(this.$commonJs.getTenantId()),
              categoryName: this.formList.categoryName,
              categoryId: this.formList.categoryId,
              bannerLink: this.formList.bannerLink,
              bannerJumpUrl: this.formList.bannerJumpUrl
            }).then((res) => {
              this.dialogShowLabel = false,
                this.jdh_qz_man_activity_page_categories()
            })
        } else {
          console.log('error submit!')
          this.$message.error('请填写完整')
        }
      })
    },
    // 合并弹框
    mergeClickHandler(val) {
      if (val === 'one') {
        this.mergeDialog = false
      } else if (val === 'two') {
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    // 移动弹框
    moveClickHandler(val) {
      if (val === 'one') {
        this.moveDialog = false
      } else if (val === 'two') {
        // this.jdh_qz_man_post_label_delete(this.tableVal)
        console.log(this.$refs, 9999);
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    // 分页
    jdh_qz_man_activity_page_categories(searchParam) {
      console.log("==== business",this.getBusinessId(this.$commonJs.getTenantId()),"tenantId",this.$commonJs.getTenantId())
      let vm = this
      jdh_qz_man_activity_page_categories({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        status: 1,
        categoryName: searchParam ? searchParam : ""
      })
        .then(res => {
          console.log("🚀 ~ jdh_qz_man_activity_page_categories ~ res:", res)
          this.tableData.tableList.splice(0, this.tableData.tableList.length)
          res.data.map(item => {
            item.updateTime = this.formatDate(item.updateTime)
            item.rowLabelList = {
              categoryName: item.categoryName,
              labelStyle: item.labelStyle,
              textStyle: item.textStyle,
              labelIcon: item?.labelIcon
            }
            item.createTime = this.formatDate(item.createTime)
            console.log("==== item", item)
            this.tableData.tableList.push(item)
          })
          vm.paginationDataProduct.total = res.totalCount
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize
        })
    },
    clickAddButton() {
      this.title = '新增'
      this.formList = {
        categoryName: "",
      }
      this.dialogShowLabel = true
    },
    handleDialog(val) {
      this.dialogShow = val
    },
    handleDialogLabel(val) {
      // dialogShowLabel
      this.dialogShowLabel = val
    },
    handleDialogSubmit() {
      this.handleDialog(false)
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false)
    },
    // 新增
    saveOrUpdateLabelGroup(name) {
      saveOrUpdateLabelGroup({
        id: this.tableVal.id == undefined ? '' : this.tableVal.id,
        labelType: 1,
        name: name,
        tenantId: this.$commonJs.getTenantId(),
      }).then(res => {
        this.isRed = false
        this.dialogShowLabel = false
        this.jdh_qz_man_activity_page_categories()
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
  },
  created() {
    this.jdh_qz_man_activity_page_categories()
  },
};
</script>

<style lang="scss" scoped>
.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 30px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}

.base-dialog-input-border {
  position: relative;

  &>input {
    border: 1px solid #F56C6C;
  }
}

.rules {
  position: absolute;
  font-size: .5em;
  color: #F56C6C;
  bottom: -28px;
  left: 0px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}
</style>
